﻿/* ==========================================================================
   Cristall Clean Pro — product page · interactions
   ========================================================================== */
(function () {
  'use strict';

  const ASSETS = window.__LANDING_ASSETS__ || 'assets/';
  /* Cache-buster for JS-built asset URLs (Shopify CDN caches per-URL; bump on image changes) */
  const ASSET_VER = '?v=20260921a';
  const SHOP = 'https://npya0y-x7.myshopify.com';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  /* Localized prices injected by the theme (window.CCP_PRICES); absent on the
     static Vercel copy, where everything stays USD. */
  const CP = window.CCP_PRICES || null;
  const CUR = (CP && CP.currency) || 'USD';
  /* Pin the format locale to the currency's home market so JS-built prices
     match the Liquid-rendered ones regardless of the visitor's browser locale */
  const CUR_LOCALE = { GBP: 'en-GB', CAD: 'en-CA', AUD: 'en-AU', NZD: 'en-NZ' }[CUR] || 'en-US';
  const money = (n) => {
    if (CUR !== 'USD')
      return n.toLocaleString(CUR_LOCALE, {
        style: 'currency',
        currency: CUR,
        minimumFractionDigits: n % 1 ? 2 : 0,
        maximumFractionDigits: 2,
      });
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  /* ------------------------------------------------------------------ DATA */

  const GALLERY = [
    /* v97b: kit shot first, lifestyle hero second (Max 2026-09-23) */
    'robot-only-kit.jpg',
    'hero1.jpg',
    'checklist.jpg',
    'problem-solution.jpg',
    'before-after.webp',
    'warranty.jpg',
    'watching.jpg',
    'using.jpg',
    'unboxing.jpg',
    'corded.jpg',
    'dimensions.jpg',
    'flatlay.jpg',
  ].map((f) => ASSETS + f + ASSET_VER);

  /* Shopify variant IDs (npya0y-x7.myshopify.com) */
  const VARIANTS = [
    /* Quantity tiers: 1 = Starter variant; 2/3 = multi-pack variants (price = order TOTAL) */
    { package: '1 Robot', qty: 1, price: 299, compare: 629, image: ASSETS + 'robot-only-kit.jpg' + ASSET_VER, shopifyId: '54483392692551' },
    { package: '2 Robots', qty: 2, price: 558, compare: 1258, image: ASSETS + 'robot-only-kit.jpg' + ASSET_VER, shopifyId: '54486594257223' },
    { package: '3 Robots', qty: 3, price: 777, compare: 1887, image: ASSETS + 'robot-only-kit.jpg' + ASSET_VER, shopifyId: '54486594289991' },
  ];
  const PADS_VARIANT_ID = '54483423068487';
  /* Package Protection: $10 add-on product (no shipping), preselected in the
     cart and clearly removable. Replaces the retired $25 Protected Shipping
     rate; checkout now has a single $14.99 Standard rate. */
  const PROTECTION_VARIANT_ID = '54752808599879';
  let PROTECTION_PRICE = 4.95;
  let protectionOn = true; /* preselected; toggle lives in the cart footer */

  /* Refill Club: two Loop monthly selling plans.
     TRIAL (bundles): 100% off first order in Loop, then 10% off recurring.
     STANDARD (Starter): 10% off recurring, billed from the first order.
     STANDARD must be created in Loop; checkout is blocked while it is PENDING. */
  const REFILL_PLAN_TRIAL = '692099088711';
  const REFILL_PLAN_STANDARD = '692103741767';
  let PADS_MONTHLY = 29.9; /* $33.22 − 10% recurring discount */
  let PADS_FULL = 33.22;

  /* Verified customer reviews (collected by email 2026-09-25, entered in Loox).
     Card images are our own product shots, not customer photos. */
  const PDP_REVIEWS = [
    {
      name: 'Katy M.',
      image: ASSETS + 'lifestyle.webp' + ASSET_VER,
      text: 'What impressed me most was how securely it stayed attached to the glass while working. The built-in safety features gave me confidence, especially when cleaning higher windows.',
    },
    {
      name: 'Mikaela F.',
      image: ASSETS + 'kit.webp' + ASSET_VER,
      text: 'I was honestly skeptical about buying a window-cleaning robot, but this one completely changed my mind. I have several large windows and a glass patio door that are difficult to clean by hand, and this machine saved me a lot of time and effort.',
    },
    {
      name: 'Amanda K.',
      image: ASSETS + 'before-after.webp' + ASSET_VER,
      text: 'It\'s definitely one of those products that feels like a luxury at first, but once you use it, you wonder how you managed without it. Highly recommended for anyone with large windows, glass doors, or hard-to-reach glass surfaces and showers!',
    },
  ];

  const REVIEW_CARDS = [
    { name: 'Ella R.', text: 'I have to say this makes my life so much easier. I was so scared of climbing up that ladder again. Last year I fell and bruised my knee and couldn\'t walk for a week! Now this saves me time and so much money. I will never call a window cleaning crew again!' },
    { name: 'Katy M.', text: 'What impressed me most was how securely it stayed attached to the glass while working. The built-in safety features gave me confidence, especially when cleaning higher windows.' },
    { name: 'Thomas B.', text: 'Since I got divorced I had to start cleaning my own windows so I started looking for something that would help me save time and then I came across this great robot! The spray system does a great job loosening dust, fingerprints, and outdoor grime, and the finished results were much cleaner than I expected.' },
    { name: 'Mikaela F.', text: 'I was honestly skeptical about buying a window-cleaning robot, but this one completely changed my mind. I have several large windows and a glass patio door that are difficult to clean by hand, and this machine saved me a lot of time and effort.' },
    { name: 'Amanda K.', text: 'It\'s definitely one of those products that feels like a luxury at first, but once you use it, you wonder how you managed without it. Highly recommended for anyone with large windows, glass doors, or hard-to-reach glass surfaces and showers!' },
  ];

  /* Customer photos from their Loox reviews (mirrored to theme assets) */
  const TRUSTED = [
    { media: ASSETS + 'cust-ella.jpg' + ASSET_VER, avatar: ASSETS + 'studio.png' + ASSET_VER, name: 'Ella R.', role: 'Customer', text: 'Now this saves me time and so much money. I will never call a window cleaning crew again!' },
    { media: ASSETS + 'cust-katy.jpg' + ASSET_VER, avatar: ASSETS + 'studio.png' + ASSET_VER, name: 'Katy M.', role: 'Customer', text: 'What impressed me most was how securely it stayed attached to the glass while working.' },
    { media: ASSETS + 'cust-mikaela.jpg' + ASSET_VER, avatar: ASSETS + 'studio.png' + ASSET_VER, name: 'Mikaela F.', role: 'Customer', text: 'I was honestly skeptical about buying a window-cleaning robot, but this one completely changed my mind.' },
    { media: ASSETS + 'cust-amanda.jpg' + ASSET_VER, avatar: ASSETS + 'studio.png' + ASSET_VER, name: 'Amanda K.', role: 'Customer', text: 'It\'s definitely one of those products that feels like a luxury at first, but once you use it, you wonder how you managed without it.' },
  ];

  const FAQ = [
    ['What surfaces can it clean?', '<p>Windows, glass doors, mirrors, shower screens, glass tabletops and smooth glazed tiles — indoors and outdoors. If it\'s flat, smooth and at least ~16 × 16 in, the Cristall Clean Pro can climb it and clean it, framed or frameless.</p>'],
    ['Is it safe on tall or high windows?', '<p>Yes — that\'s the whole point. Three layers of protection work together: continuous high-power suction grips the glass, a backup power reserve keeps that grip alive even if the plug is pulled, and the included safety tether anchors the robot to the window frame for extra peace of mind on high or exterior panes.</p>'],
    ['How long does setup take?', '<p>About half a minute — and that is the part that surprises people who already own robot vacuums. No app pairing, no mapping run: plug it in, clip on a microfibre pad, fill the spray tank, set it on the glass, and press start. The robot then does the long part while you do something else.</p>'],
    ['Does it need plumbing or batteries?', '<p>Neither. It plugs into a standard outlet and cleans continuously — no batteries to charge or swap mid-job. You fill the onboard spray reservoir with water (plus a splash of glass solution if you like), clip on a microfibre pad, and press start.</p>'],
    ['How does it avoid falling or missing spots?', '<p>Edge-detection sensors find the borders of the pane, then the robot plans a zig-zag route that covers every inch — corners included. It detects frames and frameless edges alike, and it won\'t drive off the glass.</p>'],
    ['How long does one window take?', '<p>Roughly 2–4 minutes per square meter depending on how dirty the glass is. A typical large living-room window takes a few minutes; a whole home\'s glass is usually done within an hour or two — while you do something else entirely.</p>'],
    ['Do I need special cleaning fluid?', '<p>No proprietary consumables. Plain water works for regular maintenance cleans; for greasy or long-neglected glass, add any standard streak-free glass solution to the reservoir.</p>'],
    ['How do I clean the pads?', '<p>Peel them off and throw them in the washing machine (up to 40°C). They\'re reusable for many cycles. We recommend rotating 2–3 pads on a big cleaning day so you\'re always starting with a fresh edge — that\'s the secret to a streak-free finish.</p>'],
    ['Is it loud?', '<p>It runs at roughly 65 dB — about the level of a normal conversation or a dishwasher. You can comfortably watch TV in the same room while it works.</p>'],
    ['Can it clean in winter or direct sun?', '<p>Yes. It works in normal outdoor temperatures — just avoid cleaning frozen glass. In strong direct summer sun the spray can dry fast, so early morning or evening gives the most flawless finish outside.</p>'],
    ['What if it doesn\'t work for my windows?', '<p>You\'re covered twice: a 90-day money-back guarantee (return it in unused condition for a full refund if it\'s not for you) and a full 4-year manufacturer warranty on the robot itself — included free with every order.</p>'],
  ];

  const BENEFIT_ITEMS = {
    'Time Back': 'A full-home window clean runs itself while you work, cook or relax — hours of scrubbing become one button press.',
    'No Ladders': 'High and hard-to-reach panes get cleaned from the ground. No climbing, no leaning out of window frames.',
    'Streak-Free Finish': 'Spray and scrub with dual roller brushes in one automated pass — the same sequence professionals use, minus the invoice.',
    'Whole-Home Glass': 'One machine for windows, mirrors, shower screens, glass doors and tiles — indoors and out.',
    'Real Savings': 'A one-time purchase replaces recurring window-service visits that typically cost $150–$400 each — often far more for multi-story homes.',
    'Cleaner, More Often': 'When cleaning is effortless, it actually happens — enjoy bright, spotless glass every week instead of twice a year.',
    'Accessible for Everyone': 'Perfect for seniors and anyone who shouldn\'t be climbing — the robot does the risky part.',
  };

  const BENEFIT_TABS = [
    { label: 'all benefits', items: Object.keys(BENEFIT_ITEMS).map((k) => [k, BENEFIT_ITEMS[k]]) },
    { label: 'TIME', items: [['Time Back', 'The average home\'s glass takes hours to clean by hand — and it never stays done. With a robot, "cleaning the windows" means pressing start and moving it between panes. The scrubbing, the reaching, the re-doing of streaks: all gone.']] },
    { label: 'safety', items: [['No Ladders, No Risk', 'Falls from ladders are one of the most common household injuries — and windows are the #1 reason people climb. The Cristall Clean Pro cleans second-floor and exterior glass while you stay safely on the ground, with a tether and backup power as double insurance.']] },
    { label: 'finish', items: [['A Professional Finish', 'Streaks come from dirty water dragged across glass. The robot works like a pro: fresh solution sprayed ahead, a dual roller-brush scrub, then a clean microfibre finish — in one continuous pass, every time, on every pane.']] },
    { label: 'versatility', items: [['Every Pane In The House', 'Shower screens with limescale, mirrors with toothpaste flecks, glass tables, tiled walls — anything flat and smooth is fair game. The bathroom glass usually ends up being the favorite use.']] },
    { label: 'savings', items: [['It Pays For Itself', 'One professional window-cleaning visit typically runs $150–$400 — multi-story homes often pay $1,000+ — and it lasts a season. The robot costs from $299 once, cleans on demand, and the only running cost is a machine-washable pad and a splash of solution.']] },
  ];

  const PAB = [
    { title: 'Spare Microfibre Pads (4-Pack)', img: 'pads.webp', price: 33.22, compare: null, rating: '—', url: SHOP + '/products/spare-microfibre-cleaning-pads-4-pack' },
  ];

  /* Patch all USD literals with market-localized prices when the theme injects
     them — keeps every derived number (savings, refills, cart totals) in the
     visitor's currency and identical to what checkout will charge. */
  if (CP) {
    VARIANTS.forEach((v) => {
      const d = CP.variants[v.shopifyId];
      if (d) {
        v.price = d.price;
        v.compare = d.compare;
      }
    });
    PADS_FULL = CP.pads;
    PADS_MONTHLY = Math.round(CP.pads * 0.9 * 100) / 100;
    PROTECTION_PRICE = CP.protection;
    PAB[0].price = CP.pads;
  }

  /* -------------------------------------------------------------- GALLERY */

  const track = $('[data-gallery-track]');
  const thumbs = $('[data-gallery-thumbs]');
  let galleryIndex = 0;

  GALLERY.forEach((src, i) => {
    const img = new Image();
    img.src = src;
    img.alt = 'Cristall Clean Pro image ' + (i + 1);
    img.loading = i < 2 ? 'eager' : 'lazy';
    track.appendChild(img);

    const t = new Image();
    t.src = src;
    t.alt = '';
    t.loading = 'lazy';
    t.addEventListener('click', () => goToSlide(i));
    thumbs.appendChild(t);
  });
  $('[data-gallery-total]').textContent = GALLERY.length;

  function goToSlide(i) {
    galleryIndex = (i + GALLERY.length) % GALLERY.length;
    track.style.transform = 'translateX(' + -galleryIndex * 100 + '%)';
    $('[data-gallery-current]').textContent = galleryIndex + 1;
    $$('img', thumbs).forEach((el, idx) => el.classList.toggle('is-active', idx === galleryIndex));
    const active = thumbs.children[galleryIndex];
    if (active) {
      thumbs.scrollTo({
        left: active.offsetLeft - thumbs.clientWidth / 2 + active.clientWidth / 2,
        behavior: 'smooth',
      });
    }
  }
  $('[data-gallery-prev]').addEventListener('click', () => goToSlide(galleryIndex - 1));
  $('[data-gallery-next]').addEventListener('click', () => goToSlide(galleryIndex + 1));
  goToSlide(0);

  // swipe
  let touchX = null;
  track.addEventListener('touchstart', (e) => (touchX = e.changedTouches[0].clientX), { passive: true });
  track.addEventListener('touchend', (e) => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 40) goToSlide(galleryIndex + (dx < 0 ? 1 : -1));
    touchX = null;
  });

  /* ------------------------------------------------------- VARIANT PICKER */

  const state = { package: '1 Robot' };
  /* Visitors land on slide 1; the offer-image jump only fires after user interaction */
  let offerImageArmed = false;

  function currentVariant() {
    return VARIANTS.find((v) => v.package === state.package) || VARIANTS[0];
  }

  function renderVariant() {
    const v = currentVariant();
    const save = v.compare - v.price;

    $('[data-price]').textContent = money(v.price);
    $('[data-compare]').textContent = money(v.compare);
    /* floor, never round up - the claim must always be at or below the true % */
    $('[data-save]').textContent = 'SAVE ' + Math.floor((save / v.compare) * 100) + '%';
    $('[data-sticky-price]').textContent = money(v.price);
    $('[data-sticky-compare]').textContent = money(v.compare);
    $$('[data-atc-price]').forEach(function (el) { el.textContent = money(v.price); });
    $$('[data-atc-compare]').forEach(function (el) { el.textContent = money(v.compare); });
    $('[data-sticky-variant]').textContent = v.package;

    $$('[data-option="package"]').forEach((el) => el.classList.toggle('is-selected', el.dataset.value === state.package));
    const giftBanner = $('[data-qty-gift]');
    if (giftBanner) giftBanner.classList.toggle('is-active', v.qty >= 2);

    /* Bundles include the Refill Club as a free-first-month gift — preselected
       on package switch but always deselectable, same as Starter. */
    const isBundle = state.package !== 'Starter';
    [
      ['#add-pads', '[data-pads-std]', '[data-pads-gift]'],
    ].forEach(([box, std, note]) => {
      if (!$(box)) return;
      $(box).checked = true;
      $(box).disabled = false;
      $(std).hidden = isBundle;
      $(note).hidden = !isBundle;
      $(box).closest('.upsell').classList.toggle('upsell--gift', isBundle);
    });
    renderSummary();
    updateOfferImage();
  }

  $$('[data-option="package"]').forEach((el) =>
    el.addEventListener('click', () => {
      state.package = el.dataset.value;
      renderVariant();
    })
  );

  renderVariant();
  offerImageArmed = true;

  /* ------------------------------------------------- REFILL CLUB SUMMARY */

  function refillSelection() {
    const isBundle = state.package !== 'Starter';
    return {
      isBundle: isBundle,
      pads: !!($('#add-pads') && $('#add-pads').checked),
    };
  }

  function renderSummary() {
    const v = currentVariant();
    const sel = refillSelection();
    const monthly = sel.pads ? PADS_MONTHLY : 0;
    const el = $('[data-order-summary]');
    if (!monthly) {
      el.innerHTML = 'Today: <b>' + money(v.price) + '</b> one-time &middot; no subscription.';
      return;
    }
    if (sel.isBundle) {
      el.innerHTML =
        'Today: <b>' + money(v.price) + '</b> incl. FREE first refill month &middot; from month 2: <b>' +
        money(monthly) + '/mo</b> refills &mdash; cancel anytime.';
    } else {
      el.innerHTML =
        'Today: <b>' + money(v.price + monthly) + '</b> (' + money(v.price) + ' robot + first refills) &middot; renews at <b>' +
        money(monthly) + '/mo</b> &mdash; cancel anytime.';
    }
  }

  /* Offer image mirrors the selected package: robot alone, Pro kit, or
     Complete flatlay — switching cards always switches the picture */
  function updateOfferImage() {
    /* single offer: all quantity tiers show the same product - no gallery jump */
    return;
    if (!offerImageArmed) return;
    let file = 'robot-only-kit.jpg';
    if (state.package === 'Complete Bundle') file = 'flatlay.jpg';
    else if (state.package === 'Pro Bundle') file = 'bundle.webp';
    const idx = GALLERY.indexOf(ASSETS + file + ASSET_VER);
    if (idx > -1) goToSlide(idx);
  }

  ['#add-pads'].forEach((id) => {
    if (!$(id)) return;
    $(id).addEventListener('change', () => {
      renderSummary();
      updateOfferImage();
    });
  });


  /* ------------------------------------------------------------------ ETA */

  (function () {
    const fmt = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    const addBusiness = (days) => {
      const d = new Date();
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) added++;
      }
      return d;
    };
    $('[data-eta]').textContent = fmt(addBusiness(3)) + ' - ' + fmt(addBusiness(7));
  })();

  /* ---------------------------------------- ROLLING DISPATCH CUTOFF DATE */
  /* Orders are handed to fulfillment DAILY (Max, 2026-09-29): the "Order by"
     date is today's SHIPPING cutoff (end of the current ET day) and rolls
     forward every midnight ET. It carries no offer-expiry claim - the gifts
     line states inclusion, not scarcity. */
  (function () {
    var els = document.querySelectorAll('[data-dispatch-date]');
    if (!els.length) return;
    var DAY = 86400000;
    var now = Date.now();
    /* next 03:59:59Z boundary (= upcoming midnight ET) at or after now */
    var end = Math.ceil((now - (3 * 3600000 + 59 * 60000 + 59000)) / DAY) * DAY
      + 3 * 3600000 + 59 * 60000 + 59000;
    var d = new Date(end - 4 * 3600000); /* the ET calendar day the window ends on */
    var day = d.getUTCDate();
    var suf = (day % 10 === 1 && day !== 11) ? 'st'
      : (day % 10 === 2 && day !== 12) ? 'nd'
      : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'];
    var label = months[d.getUTCMonth()] + ' ' + day + suf;
    els.forEach(function (el) { el.textContent = label; });
    var ann = document.querySelector('[data-announce]');
    if (ann) ann.setAttribute('data-deadline', new Date(end).toISOString());
  })();

  /* -------------------------------------------------------- REVIEW STRIP */

  (function () {
    const wrap = $('[data-review-strip]');
    REVIEW_CARDS.forEach((r) => {
      const el = document.createElement('article');
      el.className = 'review-card';
      el.innerHTML =
        (r.image ? '<img loading="lazy" src="' + r.image + '" alt="' + r.name + '">' : '') +
        '<div class="review-card__body">' +
        '<div class="review-card__stars">★★★★★</div>' +
        '<div class="review-card__name">' + r.name + '</div>' +
        '<p class="review-card__text">' + r.text + '</p></div>';
      wrap.appendChild(el);
    });
  })();

  /* ------------------------------------------------------ TRUSTED REVIEWS */

  (function () {
    const wrap = $('[data-trusted]');
    TRUSTED.forEach((t) => {
      const el = document.createElement('article');
      el.className = 'trusted-card';
      el.innerHTML =
        '<img class="trusted-card__media" loading="lazy" src="' + t.media + '" alt="' + t.name + '">' +
        '<div class="trusted-card__body">' +
        '<div class="trusted-card__author"><img loading="lazy" src="' + t.avatar + '" alt="">' +
        '<div><h5>' + t.name + '</h5><span>' + t.role + '</span></div></div>' +
        '<p class="trusted-card__text">' + t.text + '</p></div>';
      wrap.appendChild(el);
    });
  })();

  /* -------------------------------------------------------------- FAQ */

  (function () {
    const wrap = $('[data-faq]');
    FAQ.forEach(([q, a]) => {
      const d = document.createElement('details');
      d.className = 'accordion';
      d.innerHTML =
        '<summary><span class="accordion__head">' +
        '<svg viewBox="0 0 20 20" width="20" height="20" fill="currentColor"><path d="M10 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm.5 13h-1v-1h1v1zm1.2-4.6l-.7.7v1.4h-1v-1.8l1.2-1.2a1.7 1.7 0 10-2.9-1.2h-1a2.7 2.7 0 115.4 0c0 .8-.4 1.5-1 2.1z"/></svg>' +
        '<span><b>' + q + '</b></span></span>' +
        '<svg class="chev" viewBox="0 0 10 6" width="12" height="8"><path d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg></summary>' +
        '<div class="accordion__body">' + a + '</div>';
      wrap.appendChild(d);
    });
  })();

  /* --------------------------------------------------------- BENEFIT TABS */

  (function () {
    const tabs = $('[data-benefit-tabs]');
    const panels = $('[data-benefit-panels]');
    const icon =
      '<svg viewBox="0 0 24 24" width="24" height="24" fill="none"><path d="M12 21.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19z" stroke="#0f7fd8" stroke-width="1.6"/><path d="M8 12.2l2.7 2.7L16 9.4" stroke="#0f7fd8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    BENEFIT_TABS.forEach((tab, i) => {
      const li = document.createElement('li');
      li.textContent = tab.label;
      li.className = i === 0 ? 'is-current' : '';
      li.addEventListener('click', () => {
        $$('li', tabs).forEach((n, ni) => n.classList.toggle('is-current', ni === i));
        $$('.panel', panels).forEach((n, ni) => n.classList.toggle('is-current', ni === i));
      });
      tabs.appendChild(li);

      const panel = document.createElement('div');
      panel.className = 'panel benefits__grid' + (i === 0 ? ' is-current' : '');
      panel.innerHTML = tab.items
        .map(
          ([title, body]) =>
            '<div class="benefit-box"><div class="benefit-box__title">' + icon + '<h5>' + title + '</h5></div><p>' + body + '</p></div>'
        )
        .join('');
      panels.appendChild(panel);
    });
  })();

  /* ------------------------------------------------------ DIFFERENCE TABS */

  $$('[data-diff-tab]').forEach((tab) =>
    tab.addEventListener('click', () => {
      $$('[data-diff-tab]').forEach((t) => t.classList.toggle('is-current', t === tab));
      $$('[data-diff-panel]').forEach((p) => p.classList.toggle('is-current', p.dataset.diffPanel === tab.dataset.diffTab));
    })
  );

  /* ---------------------------------------------------- PEOPLE ALSO BOUGHT */

  (function () {
    const wrap = $('[data-pab]');
    if (!wrap) return; /* v98f: PAB section removed from PDP */
    PAB.forEach((p) => {
      const save = p.compare ? p.compare - p.price : 0;
      const el = document.createElement('article');
      el.className = 'pab-card';
      el.innerHTML =
        '<a href="' + p.url + '"><img loading="lazy" src="' + ASSETS + p.img + ASSET_VER + '" alt="' + p.title + '"></a>' +
        '<div class="pab-card__body">' +
        '<h3><a href="' + p.url + '" style="text-decoration:none">' + p.title + '</a></h3>' +
        '<div class="pab-card__prices">' +
        (p.compare ? '<s>' + money(p.compare) + '</s>' : '') +
        '<b>' + money(p.price) + '</b>' +
        (save ? '<span class="pab-card__save">' + money(save) + ' off</span>' : '') +
        '</div></div>';
      wrap.appendChild(el);
    });
  })();

  /* --------------------------------------------------------------- DRAWERS */

  const menuDrawer = $('[data-drawer]');
  const menuOverlay = $('[data-drawer-overlay]');
  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');

  const openEl = (el, ov) => {
    el.classList.add('is-open');
    ov.classList.add('is-open');
    document.body.classList.add('no-scroll');
  };
  const closeAll = () => {
    [menuDrawer, cartDrawer].forEach((e) => e.classList.remove('is-open'));
    [menuOverlay, cartOverlay].forEach((e) => e.classList.remove('is-open'));
    document.body.classList.remove('no-scroll');
  };

  $('[data-drawer-open]').addEventListener('click', () => openEl(menuDrawer, menuOverlay));
  $('[data-drawer-close]').addEventListener('click', closeAll);
  menuOverlay.addEventListener('click', closeAll);
  $('[data-cart-open]').addEventListener('click', () => openEl(cartDrawer, cartOverlay));
  $('[data-cart-close]').addEventListener('click', closeAll);
  cartOverlay.addEventListener('click', closeAll);
  // close the menu drawer when tapping an anchor inside it
  $$('.menu-drawer a').forEach((a) => a.addEventListener('click', closeAll));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll();
      $$('.modal.is-open').forEach((m) => m.classList.remove('is-open'));
    }
  });

  /* ---------------------------------------------------------------- MODALS */

  $$('[data-modal-open]').forEach((btn) =>
    btn.addEventListener('click', () => {
      const m = document.getElementById(btn.dataset.modalOpen);
      if (m) {
        m.classList.add('is-open');
        document.body.classList.add('no-scroll');
      }
    })
  );
  $$('[data-modal]').forEach((modal) => {
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.closest('[data-modal-close]')) {
        modal.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
      }
    });
  });

  /* ------------------------------------------------------------------ CART */

  const cart = [];

  function renderCart() {
    const body = $('[data-cart-items]');
    const count = cart.reduce((n, i) => n + i.qty, 0);
    const subtotal = cart.reduce((n, i) => n + i.price * i.qty, 0);
    const saved = cart.reduce((n, i) => n + Math.max(0, (i.compare || i.price) - i.price) * i.qty, 0);

    const bubble = $('[data-cart-count]');
    bubble.textContent = count;
    bubble.classList.toggle('is-visible', count > 0);

    if (!cart.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
    } else {
      body.innerHTML = cart
        .filter((i) => !i.qtyGift)
        .map(
          (i, idx) =>
            '<div class="cart-item"><img src="' + i.image + '" alt="">' +
            '<div><p class="cart-item__title">' + i.title + '</p>' +
            '<p class="cart-item__variant">' + i.variant + '</p>' +
            (i.gift || i.sub
              ? (i.locked ? '</div>' : '<button class="cart-item__remove" data-remove="' + idx + '">Remove</button></div>')
              : '<div class="cart-item__qty">' +
                '<button data-qty="-1" data-idx="' + idx + '">−</button><span>' + i.qty + '</span>' +
                '<button data-qty="1" data-idx="' + idx + '">+</button></div>' +
                '<button class="cart-item__remove" data-remove="' + idx + '">Remove</button></div>') +
            '<div class="cart-item__prices"><b>' + (i.gift ? 'FREE' : money(i.price * i.qty) + (i.sub ? '/mo' : '')) + '</b>' +
            (i.compare ? '<s>' + money(i.compare * i.qty) + '</s>' : '') + '</div></div>'
        )
        .join('');
      const qg = cart.find((i) => i.qtyGift);
      if (qg) {
        body.innerHTML +=
          '<div class="cart-gift-card"><img src="' + qg.image + '" alt="">' +
          '<div class="cart-gift-card__body"><b>' + qg.title + '</b>' +
          '<small>Fall Sale exclusive gift</small>' +
          '<span class="cart-gift-card__price"><s>' + money(qg.compare) + '</s> FREE</span></div>' +
          '<span class="cart-gift-card__badge">UNLOCKED</span></div>';
      }
    }

    const protActive = protectionOn && cart.length > 0;
    const grandTotal = subtotal + (protActive ? PROTECTION_PRICE : 0);
    $('[data-cart-total]').textContent = money(grandTotal);
    $('[data-cart-subtotal]').textContent = money(grandTotal + saved);
    $('[data-cart-save]').textContent = '-' + money(saved);
    $('[data-subtotal-row]').hidden = saved <= 0;
    $('[data-save-row]').hidden = saved <= 0;
    $('[data-protect-row]').hidden = !cart.length;
    $('[data-protect-toggle]').checked = protectionOn;

    $('[data-rewards-msg]').innerHTML =
      subtotal > 0
        ? '✓ Included with every order: <b>90-day money-back guarantee</b>'
        : 'Add a robot to start your <b>90-day money-back guarantee</b>';
  }

  $('[data-cart-items]').addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty]');
    const rmBtn = e.target.closest('[data-remove]');
    if (qtyBtn) {
      const item = cart[+qtyBtn.dataset.idx];
      item.qty += +qtyBtn.dataset.qty;
      if (item.qty < 1) cart.splice(+qtyBtn.dataset.idx, 1);
      renderCart();
    } else if (rmBtn) {
      cart.splice(+rmBtn.dataset.remove, 1);
      renderCart();
    }
  });

  $('[data-protect-toggle]').addEventListener('change', (e) => {
    protectionOn = e.target.checked;
    renderCart();
  });

  function addToCart(item) {
    const found = cart.find((i) => i.shopifyId === item.shopifyId && (i.sellingPlan || null) === (item.sellingPlan || null));
    if (found) {
      if (!item.gift && !item.sub) found.qty += item.qty || 1; /* refill lines stay at qty 1 */
    } else cart.push(Object.assign({ qty: 1 }, item));
  }

  /* Meta Pixel events. On Shopify the pixel loads async via the Meta sales
     channel web pixel, so queue events until window.fbq exists (max ~20s). */
  const fbQueue = [];
  let fbTimer = null;
  function fbFlush() {
    while (fbQueue.length) {
      const e = fbQueue.shift();
      fbq('track', e[0], e[1]);
    }
  }
  function fbTrack(event, data) {
    if (window.fbq) {
      fbq('track', event, data);
      return;
    }
    fbQueue.push([event, data]);
    if (!fbTimer) {
      let tries = 0;
      fbTimer = setInterval(function () {
        if (window.fbq) {
          clearInterval(fbTimer);
          fbFlush();
        } else if (++tries > 40) clearInterval(fbTimer);
      }, 500);
    }
  }
  fbTrack('ViewContent', {
    content_name: 'Cristall Clean Pro',
    content_type: 'product',
    content_ids: [VARIANTS[0].shopifyId],
    value: VARIANTS[0].price,
    currency: CUR,
  });

  $$('[data-atc]').forEach((btn) =>
    btn.addEventListener('click', () => {
      const v = currentVariant();
      /* one robot line only - re-adding swaps to the selected quantity tier */
      for (let i = cart.length - 1; i >= 0; i--)
        if (VARIANTS.some((t) => t.shopifyId === cart[i].shopifyId) || cart[i].qtyGift) cart.splice(i, 1);
      addToCart({
        title: 'Cristall Clean Pro',
        variant: v.package,
        price: v.price,
        compare: v.compare,
        image: v.image,
        shopifyId: v.shopifyId,
      });
      if (v.qty >= 2) {
        /* 2+ robots unlock the pads 8-pack gift (display line; value = 2x real 4-pack price) */
        addToCart({
          title: 'Spare Microfibre Pads (8-Pack)',
          variant: 'FREE gift - 2+ robots',
          price: 0,
          compare: 66.44,
          image: ASSETS + 'pads.webp' + ASSET_VER,
          shopifyId: 'gift-8pack',
          gift: true,
          qtyGift: true,
          qty: 1,
        });
      }

      fbTrack('AddToCart', {
        content_name: 'Cristall Clean Pro',
        content_type: 'product',
        content_ids: [v.shopifyId],
        value: v.price,
        currency: CUR,
      });

      const sel = refillSelection();

      /* Refill Club lines: real Shopify variants on a Loop monthly plan.
         Bundles: TRIAL plan — first order FREE, billing starts month 2 (preselected, removable).
         Starter: STANDARD plan — billed monthly from today (removable). */
      if (sel.pads) {
        addToCart({
          title: 'Spare Microfibre Pads (4-Pack)',
          variant: sel.isBundle
            ? 'Included: 1st month FREE · then ' + money(PADS_MONTHLY) + '/mo · cancel anytime'
            : money(PADS_MONTHLY) + '/mo · billed monthly from today · cancel anytime',
          price: sel.isBundle ? 0 : PADS_MONTHLY,
          compare: PADS_FULL,
          image: ASSETS + 'pads.webp' + ASSET_VER,
          shopifyId: PADS_VARIANT_ID,
          sellingPlan: sel.isBundle ? REFILL_PLAN_TRIAL : REFILL_PLAN_STANDARD,
          gift: sel.isBundle,
          sub: true,
          locked: false,
          qty: 1,
        });
      }

      renderCart();
      openEl(cartDrawer, cartOverlay);
    })
  );

  /* Real checkout: hand the cart to the Shopify store via a cart permalink */
  $('[data-checkout]').addEventListener('click', () => {
    if (!cart.length) return;
    /* Refill lines carry a selling plan and DO go to checkout; only purely
       cosmetic gift lines (no plan) are display-only. */
    const items = cart.filter((i) => !i.gift || i.sellingPlan);
    if (protectionOn) items.push({ shopifyId: PROTECTION_VARIANT_ID, qty: 1, price: PROTECTION_PRICE });
    fbTrack('InitiateCheckout', {
      content_type: 'product',
      content_ids: items.map((i) => i.shopifyId),
      value: items.reduce((s, i) => s + i.price * i.qty, 0),
      num_items: items.reduce((s, i) => s + i.qty, 0),
      currency: CUR,
    });
    if (items.some((i) => i.sellingPlan === 'PENDING_LOOP_PLAN_ID')) {
      /* Safety net: the standard refill plan is not wired up yet */
      alert('Checkout is being updated — please try again in a few minutes.');
      return;
    }
    if (items.some((i) => i.sellingPlan)) {
      /* /cart/add supports per-line selling plans; the permalink format does not */
      const params = items
        .map(
          (i, n) =>
            'items[' + n + '][id]=' + i.shopifyId +
            '&items[' + n + '][quantity]=' + i.qty +
            (i.sellingPlan ? '&items[' + n + '][selling_plan]=' + i.sellingPlan : '')
        )
        .join('&');
      /* /cart/add APPENDS to any existing Shopify cart (repeat checkouts
         stacked duplicate lines) - clear the cart first, then add. */
      window.location.href = SHOP + '/cart/clear?return_to=' + encodeURIComponent('/cart/add?' + params + '&return_to=/checkout');
    } else {
      window.location.href = SHOP + '/cart/' + items.map((i) => i.shopifyId + ':' + i.qty).join(',');
    }
  });

  renderCart();

  /* ------------------------------------------------------------ STICKY ATC */

  const stickyBar = $('[data-sticky-atc]');
  const atcAnchor = $('.atc-wrap');
  const footerEl = $('.footer');

  function updateSticky() {
    const atcBottom = atcAnchor.getBoundingClientRect().bottom;
    const footerTop = footerEl.getBoundingClientRect().top;
    stickyBar.classList.toggle('is-visible', atcBottom < 0 && footerTop > window.innerHeight);
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();

  $('[data-sticky-change]').addEventListener('click', (e) => {
    e.preventDefault();
    $('#product-info').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* --------------------------------------------------------- CONTACT FORM */

  $('[data-contact-form]').addEventListener('submit', (e) => {
    e.preventDefault();
    $('[data-contact-note]').hidden = false;
  });

  /* ------------------------------------------------------------- MARQUEES */

  $$('[data-marquee]').forEach((m) => {
    const clone = m.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    m.parentNode.appendChild(clone);
  });

  /* ------------------------------------------- LOCALIZED PRICE TEXT FILLS */

  /* Shipping is a fixed USD rate, not a product price, so it has no exact
     market price. Convert via Shopify's live rate when available, else via
     the robot variant's own conversion ratio (already market-rounded). */
  (function () {
    const shipEl = $('[data-ship-price]');
    if (shipEl && CUR !== 'USD') {
      let rate = null;
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
        rate = parseFloat(window.Shopify.currency.rate);
      if (!rate && CP && CP.variants['54483392692551']) rate = CP.variants['54483392692551'].price / 299;
      if (rate) shipEl.textContent = money(Math.round(14.99 * rate * 100) / 100);
    }
    const rm = $('[data-refill-monthly]');
    if (rm) rm.textContent = money(PADS_MONTHLY);
    /* Us vs. Them price row: ours = live localized price; the $400-500 range
       for comparable robots is a USD market figure, converted approximately */
    const vsOurs = $('[data-vs-ours]');
    if (vsOurs) vsOurs.textContent = money(VARIANTS[0].price);
    const vsOthers = $('[data-vs-others]');
    if (vsOthers && CUR !== 'USD') {
      let vr = null;
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
        vr = parseFloat(window.Shopify.currency.rate);
      if (!vr && CP && CP.variants['54483392692551']) vr = CP.variants['54483392692551'].price / 299;
      if (vr) vsOthers.textContent = money(Math.round((400 * vr) / 10) * 10) + '–' + money(Math.round((500 * vr) / 10) * 10);
    }
  })();
})();

/* v98e: announcement-bar countdown to the real gift-window deadline (data-deadline).
   Hides itself when the window expires - never counts to a fake target. */
(() => {
  const bar = document.querySelector('[data-announce]');
  if (!bar) return;
  const timer = bar.querySelector('[data-announce-timer]');
  const end = Date.parse(bar.getAttribute('data-deadline') || '');
  if (!timer || !end) return;
  const h = timer.querySelector('[data-t-h]');
  const m = timer.querySelector('[data-t-m]');
  const s = timer.querySelector('[data-t-s]');
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const d = end - Date.now();
    if (d <= 0) { timer.hidden = true; return; }
    timer.hidden = false;
    const secs = Math.floor(d / 1000);
    h.textContent = pad(Math.floor(secs / 3600));
    m.textContent = pad(Math.floor((secs % 3600) / 60));
    s.textContent = pad(secs % 60);
    setTimeout(tick, 1000);
  };
  tick();
})();
